import { PopoverComponent, popoverTemplate } from './Popover';
import styles from './Popover.styles.scss';
import moreItemNavItemStyles from '../NavigationRail/moreItemPopoverOverrides.styles.scss';
export const popoverDefinition = {
    baseName: 'popover',
    template: popoverTemplate,
    styles: `${styles}${moreItemNavItemStyles}`,
};
export const chameleonPopover = PopoverComponent.compose(popoverDefinition);
